import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  readonly email = 'contacto@westpackaging.cl';
  readonly linkedInUrl = 'https://www.linkedin.com/company/western-packaging/';
  readonly whatsappUrl = 'https://wa.me/56988275330';
}

